import apiClient from './apiClient';

export interface GeoRestriction {
  _id: string;
  countryCode: string;
  countryName: string;
  region?: string;
  restrictionType: 'block' | 'allow';
  reason?: string;
  isActive: boolean;
  restrictedFeatures: string[];
  createdBy?: {
    _id: string;
    username: string;
    name: string;
  };
  createdAt: string;
  updatedAt: string;
}

class GeoRestrictionService {
  async getAllRestrictions(filters?: { isActive?: boolean; restrictionType?: string }) {
    const params = new URLSearchParams();
    if (filters?.isActive !== undefined) {
      params.append('isActive', filters.isActive.toString());
    }
    if (filters?.restrictionType) {
      params.append('restrictionType', filters.restrictionType);
    }
    const response = await apiClient.get(`/admin/geo-restrictions?${params.toString()}`);
    return response.data;
  }

  async getRestrictionById(id: string) {
    const response = await apiClient.get(`/admin/geo-restrictions/${id}`);
    return response.data;
  }

  async createRestriction(data: Partial<GeoRestriction>) {
    const response = await apiClient.post('/admin/geo-restrictions', data);
    return response.data;
  }

  async updateRestriction(id: string, data: Partial<GeoRestriction>) {
    const response = await apiClient.put(`/admin/geo-restrictions/${id}`, data);
    return response.data;
  }

  async deleteRestriction(id: string) {
    const response = await apiClient.delete(`/admin/geo-restrictions/${id}`);
    return response.data;
  }
}

export const geoRestrictionService = new GeoRestrictionService();
export default geoRestrictionService;

